import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import MobileLayout from '../../components/MobileLayout'
import Header from '../../components/atoms/Header'
import Text from '../../components/atoms/Text'
import QuestionairreInfoSheet from '../../components/organisms/QuestionairreInfoSheet'
import ArrowIcon from '../../components/atoms/Arrow'
import Button from '../../components/atoms/GoodFlipButton'
import SlideUpPanel from '../../components/atoms/SlideUpPanel'

import ChakraSVG from '../../assets/images/chakra.svg'
import CancelIcon from '../../assets/icons/cancel_icon.svg'

const FoodScanProceed = () => {
  const navigate = useNavigate()
  const QuestionairreInfoSheetRef = useRef(null)
  const { capturedImage } = useSelector((state) => state.foodScan)
  const queryParams = new URLSearchParams(location.search)
  const from = queryParams.get('') ?? 'home'

  useEffect(() => {
    if (!capturedImage) {
      navigate('/scan-food/capture')
    }
  }, [])

  const navigateBack = () => {
    // dispatch(setCapturedImage(null))
    navigate('/scan-food/capture')
  }

  const handleProceed = () => {
    if (from === 'home') {
      navigate('/ckd/questionnaire?from=PNDS')
    }
  }
  return (
    <>
      <MobileLayout>
        <div className="h-full">
          <Header showProgressBar={false} onPressLeftIcon={navigateBack} />
          <div className="h-[calc(100dvh-48px)] flex flex-col justify-between ">
            <div className="pt-2 px-4 lg:max-w-2xl lg:mx-auto">
              <Text
                variant={'headline'}
                tag="p"
                size="small"
                className={'text-text-primary'}
              >
                Kudos! You're making great progress.
              </Text>
              <div className="relative flex items-center justify-center mt-6">
                <img
                  src={ChakraSVG}
                  className="absolute top-0 -translate-x-[50%]"
                />
                <img
                  src={capturedImage}
                  className="w-[160px] h-auto relative z-20 bg-red-300 rounded-xl"
                />
                <img
                  src={ChakraSVG}
                  className="absolute top-0 translate-x-[50%]"
                />
              </div>
              <Text
                variant="title"
                size="medium"
                tag="p"
                className={'text-text-secondary mt-5'}
              >
                Next, you will answer a few questions about yourself. This will
                help understand your kidney condition.
              </Text>
            </div>
            <div className=" bottom-0 px-4 w-full">
              <div className="border-t-2 border-border-secondary w-full flex flex-col items-center">
                <div className="flex flex-col items-center justify-center gap-1">
                  <Text
                    variant="body"
                    tag="div"
                    size="large"
                    className={'text-text-primary mt-4'}
                  >
                    Want to know more about this questionnaire?
                  </Text>
                  <div className="flex items-center gap-2">
                    <Text
                      variant="label"
                      size="large"
                      className={'text-[#199EA5] underline !font-bold'}
                      onClick={() => {
                        QuestionairreInfoSheetRef?.current?.show()
                      }}
                    >
                      See How It Works
                    </Text>
                    <ArrowIcon color="#199EA5" direction="right" />
                  </div>
                  <div className="w-full mt-7 mb-6">
                    <Button
                      title={from === 'home' ? 'Proceed' : 'Continue'}
                      onClick={() => handleProceed(from)}
                      className="!w-full !mx-0 "
                      type="goodflip_primary"
                      rightIcon={<ArrowIcon direction="right" />}
                      leftIcon={null}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MobileLayout>
      <SlideUpPanel
        ref={QuestionairreInfoSheetRef}
        header={
          <div className="sticky flex justify-end items-center p-3">
            <button
              onClick={() => {
                QuestionairreInfoSheetRef?.current?.hide()
              }}
              className="p-1.5 rounded-full bg-white border-2 border-[#F2F4F7] "
            >
              <img src={CancelIcon} />
            </button>
          </div>
        }
      >
        <QuestionairreInfoSheet />
      </SlideUpPanel>
    </>
  )
}

export default FoodScanProceed
